import { Directive, ElementRef, HostListener, Inject, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;

export const YEAR_FORMATS = {
  parse: { dateInput: 'YYYY' },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

export class CustomMomentYearAdapter extends MomentDateAdapter {
  constructor(
    @Inject(MAT_DATE_LOCALE) dateLocale: string,
    @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS) options?: any
  ) {
    super(dateLocale, options);
  }

  parse(value: any, parseFormat: any): Moment | null {
    if (value && typeof value === 'string') {
      const strVal = value.trim();
      if (/^\d{4}$/.test(strVal)) {
        const date = moment(strVal, 'YYYY', true);
        return date.isValid() ? date : this.invalid();
      }
      return this.invalid();
    }
    return super.parse(value, parseFormat);
  }

  format(date: Moment, displayFormat: string): string {
    if (date && date.isValid()) {
      if (date.year() < 1000) return '';
      return date.format('YYYY');
    }
    return '';
  }
}

@Directive({
  selector: '[appYearFormat]',
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomMomentYearAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS },
  ],
})
export class YearFormatDirective {

  constructor(
    private el: ElementRef,
    @Optional() private ngControl: NgControl
  ) {}

  // 1. CHẶN KHÔNG CHO GÕ QUÁ 4 SỐ (Ngăn chặn bàn phím + Paste)
  @HostListener('input', ['$event'])
  onInput(event: any) {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Chỉ giữ lại số

    // Nếu dài quá 4 số -> Cắt đúng 4 số
    if (value.length > 4) {
      value = value.substring(0, 4);
    }

    // Nếu chưa đủ 4 số -> Ép giữ nguyên hiển thị chuỗi thô trên HTML Input
    // Ngăn Angular Material tự động format biến thành '0001'
    input.value = value;

    // Cập nhật giá trị thô vào Form Control để validator yearValidator() bắt lỗi sai định dạng
    if (this.ngControl && this.ngControl.control) {
      if (value.length < 4) {
        // Cố tình đẩy chuỗi ngắn (< 4 số) để yearValidator nhận biết & báo lỗi invalidYearFormat
        this.ngControl.control.setValue(value, { emitEvent: false });
      }
    }
  }

  // 2. CHẶN CÁC PHÍM KHÔNG PHẢI SỐ VÀ PHÍM GÕ KHI ĐÃ ĐỦ 4 SỐ
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = this.el.nativeElement as HTMLInputElement;
    const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

    if (allowedKeys.indexOf(event.key) !== -1) {
      return; // Cho phép bấm phím điều hướng / xóa
    }

    // Nếu nhập không phải là số -> Chặn
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    // Nếu đã đủ 4 số và không bôi đen chữ nào -> Chặn không cho gõ thêm
    const isTextSelected = input.selectionStart !== input.selectionEnd;
    if (input.value.length >= 4 && !isTextSelected) {
      event.preventDefault();
    }
  }
}